module.exports = __webpack_public_path__ + "assets/img/tx120_2.6c04f5ac.jpg";